<template>
  <v-row>
    <v-col
      xl="6" 
      lg="6" 
      md="6" 
      sm="12"
      xs="12">
      <v-row>
        <v-col 
          cols="12">
          <devices-filter 
            :filter="deviceListFilter"
            @updateFilter="onUpdateFilter"
            @resetFilter="onFilterReset" />
        </v-col>
        <v-col 
          cols="12">
          <devices-table 
            v-if="displayTable"
            :selectedDevice="selectedDevice"
            :loading="loadingDevices"
            :filter="deviceListFilter"
            :devices="devices"
            :devicesCount="devicesCount"
            @updateFilter="updateFilterAction"
            @onUpdateSelectedDevice="onDevicesTableRowSelected"
            @onDeleteDeviceRequest="onDeleteDeviceRequest" />
        </v-col>
      </v-row>
    </v-col>

    <v-col 
      xl="6"
      lg="6" 
      md="6" 
      sm="12"
      xs="12">
      <v-row>
        <v-col cols="12">
          <devices-map 
            :loading="loadingDevices"
            :selectedDevice="selectedDevice"
            :markers="markers"
            @onDeviceSelected="onDeviceSelected" />
        </v-col>
      </v-row>
    </v-col>

    <v-dialog 
      v-model="showConfirmationDialog"
      @input="resetDeviceIdToDelete"
      max-width="500px">

      <confirmation-dialog-content
        :loadingSubmitBtn="loadingDevices"
        @onCancel="showConfirmationDialog = false"
        @onSubmit="triggerDeviceDeletingAction"
        :text="deleteDeviceConfirmationMsg"
        :submitBtnTxt="$t('common.form.delete')"
        :cancelBtnTxt="$t('common.form.cancel')"
        />
    </v-dialog>
  </v-row>
</template>

<script>
import * as actions from '@/store/actions.type';
import * as routeConstants from '@/router/constants';
import { 
  NOTIFICATION_ERROR
} from '@/common/event.types';
import {
  mapActions,
  mapGetters
} from 'vuex';
import DevicesFilter from '@/components/devices/DevicesFilter';
import DevicesTable from '@/components/devices/DevicesTable';
import DevicesMap from '@/components/devices/DevicesMap';
import { STATUS_CODES } from '@/constants';
import ConfirmationDialogContent from '@/components/dialogs/ConfirmationDialogContent';
import { 
  DEVICE_TYPE_ARR,
} from '@/constants/device.js';

export default {
  name: 'devices',
  computed: {
    ...mapGetters([
      'devices',
      'loadingDevices',
      'deviceListFilter',
      'devicesCount'
    ]),
    markers() {
      const markersArr = [];

      if(this.devices && this.devices.length) {
        this.devices.forEach(device => {
          if(device.lastLocation) {
            markersArr.push({
              id: device.id,
              position: {
                lat: device.lastLocation.latitude,
                lng: device.lastLocation.longitude
              },
              title: device.name,
              info: this.$t(`device.type.${DEVICE_TYPE_ARR[device.type]}`)
            })
          }
        })
      }

      return markersArr;
    }
  },
  data: () => ({
    routeConstants,
    selectedDevice: null,
    showConfirmationDialog: false,
    deleteDeviceConfirmationMsg: '',
    deviceIdToDelete: null,
    displayTable: true
  }),
  methods: {
    ...mapActions({
      updateFilterAction: actions.UPDATE_DEVICES_FILTER,
      deleteDeviceAction: actions.DELETE_DEVICE
    }),
    onUpdateFilter(filter) {
      const context = this;
      filter.skip = 0;
      filter.take = 10;
      filter.page = 1;

      this.displayTable = false;
      this.updateFilterAction(filter);

      setTimeout(function() {
        context.displayTable = true;
      });
    },
    onDeviceSelected(device) {
      this.selectedDevice = device;
    },
    onFilterReset() {
      this.updateFilterAction();
    },
    onDevicesTableRowSelected(device) {
      if(device) {
        this.selectedDevice = {
          id: device.id,
          position: {
            lat: device.lastLocation.latitude,
            lng: device.lastLocation.longitude
          }
        }
      } else {
        this.selectedDevice = null;
      }
    },
    onDeleteDeviceRequest(device) {
      this.deviceIdToDelete = device.id;
      this.deleteDeviceConfirmationMsg = this.$t('device.deleteConfirmation', { deviceName: device.name })
      this.showConfirmationDialog = true;
    },
    async triggerDeviceDeletingAction() {
      await this.deleteDeviceAction(this.deviceIdToDelete);
      this.showConfirmationDialog = false;
    },
    resetDeviceIdToDelete(showConfirmationDialog) {
      if(!showConfirmationDialog) {
        this.deviceIdToDelete = null;
      }
    }
  },
  components: {
    DevicesFilter,
    DevicesTable,
    DevicesMap,
    ConfirmationDialogContent
  }
}
</script>
